/* ===== OBALUS BOGO LANDING — shared behaviour ===== */
(function () {
  if (window.__bogoLandingInit) return;
  window.__bogoLandingInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- UpCart bridge ----------
     UpCart exposes flat globals (window.upcartOpenCart / upcartRefreshCart),
     not a namespaced object. Older/alternative names kept as fallbacks. */
  window.bogoCart = {
    refresh: function () {
      try {
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      } catch (e) {}
    },
    open: function () {
      try {
        if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return true; }
        if (window.upcart && typeof window.upcart.openCart === 'function') { window.upcart.openCart(); return true; }
        if (typeof window.openCart === 'function') { window.openCart(); return true; }
      } catch (e) {}
      return false;
    },
    /* Try now; if UpCart hasn't booted yet, retry briefly before giving up. */
    openWhenReady: function (onFail) {
      if (this.open()) return;
      var tries = 0, self = this;
      var t = setInterval(function () {
        tries++;
        if (self.open() || tries > 12) {          /* ~1.8s */
          clearInterval(t);
          if (tries > 12 && typeof onFail === 'function') onFail();
        }
      }, 150);
    }
  };


  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.bogo-landing [data-reveal]'));
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.style.transitionDelay = (el.dataset.reveal || 0) + 'ms';
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { threshold: 0.1 });

    els.forEach(function (el) {
      if (!el.classList.contains('is-in')) io.observe(el);
    });
  }

  /* ---------- lazy video ----------
     Videos carry data-src instead of src, so nothing downloads until the
     element is close to the viewport. Off-screen videos are paused so the
     browser stops decoding frames it isn't showing. */
  function initVideo() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('.bogo-landing video[data-src]'));
    if (!vids.length) return;

    function load(v) {
      if (v.dataset.loaded) return;
      v.dataset.loaded = '1';
      v.src = v.dataset.src;
      v.load();
      v.setAttribute('data-loaded', '1');
    }
    function play(v) {
      load(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      vids.forEach(play);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          play(v);
        } else if (v.dataset.loaded && !v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '1200px 0px', threshold: 0.01 });

    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- pause decorative spin/pulse when off-screen ---------- */
  function initIdleAnimations() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('.bogo-landing [data-anim]'));
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.style.animationPlayState = e.isIntersecting ? 'running' : 'paused';
      });
    }, { rootMargin: '100px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    initReveal();
    initVideo();
    initIdleAnimations();
  }

  /* ---------- background media warm-up (v2) ----------
     Order matters: tiny critical pixels first (video posters + CSS backgrounds
     that content-visibility would otherwise defer), then lazy images with a
     little parallelism, then the heavy videos one by one. */
  function warmMedia() {
    var posters = [], bgs = [], imgs = [], vids = [], seen = {};
    function push(list, url) {
      if (!url || seen[url]) return;
      seen[url] = 1;
      list.push(url);
    }

    document.querySelectorAll('.bogo-landing video[poster]').forEach(function (v) {
      push(posters, v.getAttribute('poster'));
    });
    document.querySelectorAll('.bogo-landing [style*="background-image"]').forEach(function (el) {
      var m = /url\(["']?([^"')]+)["']?\)/.exec(el.getAttribute('style') || '');
      if (m) push(bgs, m[1]);
    });
    document.querySelectorAll('.bogo-landing img[loading="lazy"]').forEach(function (img) {
      push(imgs, img.currentSrc || img.src);
    });
    document.querySelectorAll('.bogo-landing video[data-src]').forEach(function (v) {
      if (!v.dataset.loaded) push(vids, v.dataset.src);
    });

    function loadImages(list, parallel, done) {
      var i = 0, active = 0, called = false;
      function finish() {
        if (!called) { called = true; done(); }
      }
      function next() {
        if (i >= list.length && active === 0) { finish(); return; }
        while (active < parallel && i < list.length) {
          active++;
          var im = new Image();
          im.onload = im.onerror = function () {
            active--;
            next();
          };
          im.src = list[i++];
        }
      }
      next();
    }
    function loadVideos(list) {
      var i = 0;
      function step() {
        if (i >= list.length) return;
        fetch(list[i++], { credentials: 'omit', mode: 'cors' })
          .then(function (r) { return r.blob(); })
          .catch(function () {})
          .then(schedule, schedule);
      }
      function schedule() {
        if ('requestIdleCallback' in window) requestIdleCallback(step, { timeout: 2000 });
        else setTimeout(step, 200);
      }
      schedule();
    }

    loadImages(posters.concat(bgs), 4, function () {
      loadImages(imgs, 3, function () {
        loadVideos(vids);
      });
    });
  }

  /* Nudge natively-lazy images to fetch well before Safari's small default
     lookahead: once within ~1600px, flip them to eager. */
  function initLazyNudge() {
    if (!('IntersectionObserver' in window)) return;
    var els = [].slice.call(document.querySelectorAll('.bogo-landing img[loading="lazy"]'));
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.loading = 'eager';
        io.unobserve(e.target);
      });
    }, { rootMargin: '1600px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function bootWarm() {
    initLazyNudge();
    setTimeout(warmMedia, 600);
  }
  if (document.readyState !== 'loading') {
    setTimeout(bootWarm, 300);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(bootWarm, 300); });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-scan when a section is re-rendered */
  document.addEventListener('shopify:section:load', init);
})();
